module.exports = __webpack_public_path__ + "media/top/icon_question_right-b6885cce.png";